import React from 'react';

// Simple cellular bars icon with color by quality
// Props: quality: 'excellent' | 'good' | 'weak' | 'unknown'; size (px), title (tooltip)
export default function SignalIcon({ quality = 'unknown', size = 18, title }) {
  const color = quality === 'excellent' ? '#16a34a' : quality === 'good' ? '#f59e0b' : quality === 'weak' ? '#ef4444' : '#9ca3af';
  const barW = Math.round(size * 0.18);
  const gap = Math.max(1, Math.round(size * 0.08));
  const base = Math.round(size * 0.25);
  const h1 = Math.round(size * 0.35);
  const h2 = Math.round(size * 0.55);
  const h3 = Math.round(size * 0.75);
  const h4 = Math.round(size * 0.95);
  const height = Math.max(h4 + base, size);
  const width = barW * 4 + gap * 3;
  const aria = title || `Signal: ${quality}`;
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      aria-label={aria}
      title={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x={0} y={height - h1} width={barW} height={h1} rx={2} fill={color} opacity={quality==='unknown'?0.35:1} />
      <rect x={barW + gap} y={height - h2} width={barW} height={h2} rx={2} fill={color} opacity={quality==='weak'?0.75:quality==='unknown'?0.35:1} />
      <rect x={(barW + gap) * 2} y={height - h3} width={barW} height={h3} rx={2} fill={color} opacity={quality==='weak'||quality==='good'?0.85:1} />
      <rect x={(barW + gap) * 3} y={height - h4} width={barW} height={h4} rx={2} fill={color} opacity={quality==='good'||quality==='weak'?0.5:1} />
    </svg>
  );
}
